// src/theme/tokens/spacing.js

export const spacing = {
  // Base spacing units
  base: 4,
  
  // Named spacing values
  xs: 4,    // Extra small: 4px
  sm: 8,    // Small: 8px
  md: 16,   // Medium: 16px
  lg: 24,   // Large: 24px
  xl: 32,   // Extra large: 32px
  xxl: 48,  // Extra extra large: 48px
  
  // Komponenten-spezifische Abstände
  components: {
    card: {
      padding: 20,
      gap: 16
    },
    form: {
      gap: 16,
      labelGap: 8
    },
    table: {
      cellPadding: 16,
      rowGap: 8
    },
    modal: {
      padding: 24
    }
  },
  
  // Layout-spezifische Abstände
  layout: {
    containerPadding: 24,
    sectionGap: 32,
    pageMargin: 48
  },
  
  // Utility function to get spacing value
  getValue: (size) => {
    if (typeof size === 'number') return size;
    return spacing[size] || spacing.base;
  }
};
